<script setup lang="ts">
import { PanelLeftClose, PanelLeftOpen } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { useSidebar } from '@/components/ui/sidebar/useSidebar'

const { open, toggleSidebar } = useSidebar()
</script>

<template>
  <div class="md:hidden">
    <Button
      variant="outline"
      size="default"
      class="w-full justify-start gap-2"
      @click="toggleSidebar"
    >
      <component :is="open ? PanelLeftClose : PanelLeftOpen" class="h-4 w-4" />
      <span>{{ open ? 'Close Sidebar' : 'Open Sidebar' }}</span>
    </Button>
  </div>
</template>
